import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
// import useMediaQuery from '@material-ui/core/useMediaQuery';
// import { useTheme } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import { WhatsApp, Facebook, Instagram } from "@material-ui/icons";

import Logo from "../../../../assets/logo-tokorame.svg";
import playstore from "../../../../assets/icon/playstore.svg";
import appstore from "../../../../assets/icon/appstore.svg";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingRight: "14%",
    paddingLeft: "14%",
    marginRight: "auto",
    marginLeft: "auto",
  },
  container_fluid: {
    paddingRight: "10%",
    paddingLeft: "10%",
    marginRight: "auto",
    marginLeft: "auto",
  },
  footer: {
    width: "100%",
    minHeight: "535px",
    backgroundColor: "#F0F1FF",
  },
  copyright: {
    position: "absolute",
    zIndex: "3",
    color: "white",
    bottom: "25px",
    fontSize: "0.8rem",
  },
  footer_logo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingTop: "50px",
    justifyContent: "center",
    "& img": {
      width: "184px",
    },
  },
  footer_copy: {
    textAlign: "center",
    marginTop: "10px",
  },
  footer_info: {
    width: "100%",
    marginTop: "60px",
    display: "flex",
    justifyContent: "space-between",
    "& a": {
      color: "inherit",
      textDecoration: "none",
      "&:hover": {
        color: "#537ED4",
      },
    },
  },
  icon_link: {
    textDecoration: "none",
    color: "inherit",
    "&:hover": {
      color: "#537ED4",
    },
    marginRight: "15px",
  },
  appstores: {
    paddingTop: "43px",
    cursor: "pointer",

    [theme.breakpoints.up(400)]: {
      display: "flex",
      marginLeft: "-30px",
      paddingTop: "43px",
      cursor: "pointer",
      textAlign: "right",
    },
  },
  alamat: {
    marginLeft: "-30px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
}));

export default function Footer() {
  const classes = useStyles();
  const [year] = useState(new Date().getFullYear());
  // const theme = useTheme();
  // const matches = useMediaQuery(theme.breakpoints.up('tablet'));
  return (
    <div className={classes.footer}>
      <div className={classes.container_fluid}>
        <div className={classes.footer_logo}>
          <img src={Logo} alt="logo" />
        </div>
        <div className={classes.footer_copy}>@ Hak Cipta {year}</div>
        <div className={classes.footer_info}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <h3>Informasi Tokorame</h3>
              <p>
                <Link
                  className={classes.footer_link}
                  onClick={() => {
                    window.open("https://tokorame.co.id/about/", "_blank");
                  }}
                >
                  Tentang Kami
                </Link>
              </p>
              <p>
                <Link
                  className={classes.footer_link}
                  onClick={() => {
                    window.open("https://tokorame.co.id/blog/", "_blank");
                  }}
                >
                  Blog
                </Link>
              </p>
              <p>
                <Link
                  className={classes.footer_link}
                  onClick={() => {
                    window.open(
                      "https://tokorame.co.id/privacy-policy/",
                      "_blank"
                    );
                  }}
                >
                  Kebijakan Privasi
                </Link>
              </p>
              <p>
                <Link
                  className={classes.footer_link}
                  onClick={() => {
                    window.open(
                      "https://tokorame.co.id/terms-and-conditions/",
                      "_blank"
                    );
                  }}
                >
                  Syarat dan Ketentuan
                </Link>
              </p>
              <p>
                <Link
                  className={classes.footer_link}
                  onClick={() => {
                    window.open(
                      "https://api.whatsapp.com/send/?phone=6281268000433&text=Halo+kak%2C+Saya+ingin+bertanya+seputar+tokorame&app_absent=0",
                      "_blank"
                    );
                  }}
                >
                  Kontak Kami
                </Link>
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.alamat}>
              <h3>Alamat</h3>
              <p>
                Lt. 2 & 3, Taman Mangu Indah. Jl. Ebony II No.9, Pd. Aren, Kec.
                Pd. Aren, Kota Tangerang Selatan, Banten 15224
              </p>
              <p>
                <Link
                  className={classes.footer_link}
                  // onClick={() => {
                  //   window.open("tokorame.co.id", "_blank");
                  // }}
                >
                  tokorame.co.id
                </Link>
              </p>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <h3>Sepatah Kata</h3>
              <p>
                Tokorame adalah platform yang membantu siapapun untuk jualan
                online tanpa perlu mikirin stok produk dan operasional lainnya
              </p>
              <h3>Hubungi Kami</h3>
              <Link
                className={classes.icon_link}
                onClick={() => {
                  window.open(
                    "https://api.whatsapp.com/send/?phone=6281268000433&text=Halo+kak%2C+Saya+ingin+bertanya+seputar+tokorame&app_absent=0",
                    "_blank"
                  );
                }}
              >
                <WhatsApp />
              </Link>
              <Link
                className={classes.icon_link}
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/tokorameofficial",
                    "_blank"
                  );
                }}
              >
                <Facebook />
              </Link>
              <Link
                className={classes.icon_link}
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/tokorameofficial/",
                    "_blank"
                  );
                }}
              >
                <Instagram />
              </Link>

              <div className={classes.appstores}>
                <Link
                  // to="/"
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.tokorame.resellerapp",
                      "_blank"
                    );
                  }}
                >
                  <img src={playstore} loading="lazy" alt="playstore-icon" />
                </Link>
                <Link
                  // to="/"
                  onClick={() => {
                    window.open(
                      "https://apps.apple.com/id/app/tokorame-reseller-app/id1551592750?l=id#?platform=iphone",
                      "_blank"
                    );
                  }}
                >
                  <img src={appstore} loading="lazy" alt="appstore-icon" />
                </Link>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
